<template>
  <div id="app">
    <navbar></navbar>  <!-- 引入导航栏组件 -->
    <router-view style="margin: 0;"/>
    <my-footer class="my-footer"></my-footer>

    <div class="container">
      <div class="language-drawer align-items-start justify-content-start"
           style="border-bottom-left-radius: 10px;
           border-top-left-radius: 10px; width: 20vw"
           :class="{ 'is-open': isDrawerOpen }">
        <div class="col-12 pl-1 mb-2 mt-2">
          <button style="background-color: rgba(0, 77, 238)" class="btn btn-sm btn-secondary i18n-class" @click="changeLanguage('zh')">中文</button>
        </div>
        <div class="col-12 pl-1 mb-2 mt-2">
          <button style="background-color: rgba(0, 77, 238)" class="btn btn-sm btn-secondary i18n-class" @click="changeLanguage('en')">English</button>
        </div>
        <!-- 这里可以添加更多内容，比如显示当前语言的文本 -->
      </div>
    </div>

    <!-- 可能需要一个触发按钮来打开抽屉 -->
    <div>
      <!-- 页面其他内容 -->
      <!-- <div class="fixed-arrow" :class="{ 'is-open': isDrawerOpen,arrowStyle }"
           @click="isDrawerOpen = !isDrawerOpen"></div> -->
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue';
import MyFooter from "@/components/MyFooter.vue";

export default {
  name: 'App',
  components: {
    MyFooter,
    Navbar
  },
  data() {
    return {
      isDrawerOpen: false
    };
  },
  computed: {
    arrowStyle() {
      return {
        right: this.isDrawerOpen ? '10vw' : '0',
        // 你可以在这里添加更多的样式，如果需要的话
      };
    },
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('locale', lang);
      // 可以选择在这里关闭抽屉
      this.isDrawerOpen = false;
    },
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
  }
};
</script>

<style lang="scss">
@import '~bootstrap/scss/bootstrap.scss';

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
   font-family: 'fzzt', Helvetica, Arial, sans-serif;
   //font-family: 'fzzt';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 确保#app至少占据整个视窗的高度 */
  overflow-x: hidden;
}

.content-wrapper {
  flex: 1; /* 使得内容部分能够扩展以填充剩余空间 */
  /* 其他样式，如padding, margin等可以根据需要添加 */
}

.my-footer {
  margin-top: 3vh;
}

/* 抽屉式容器的样式 */
.language-drawer {
  position: fixed;
  top: 20%;
  right: 0;
  z-index: 1000; /* 确保抽屉在顶层 */
  background-color: #fff;
  transition: transform 0.3s ease;
  transform-origin: right center;
  /* 默认隐藏抽屉，通过is-open类来控制显示 */
  transform: translateX(100%);
  width: 11vw;
}

.language-drawer.is-open {
  transform: translateX(0);
}

.fixed-arrow {
  position: fixed;
  top: 20%;
  /* right 属性将由箭头Style动态设置 */
  width: 30px;
  height: 30px;
  background-image: url('assets/images/arrow.png');
  background-size: cover;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: right 0.3s ease;
}

.i18n-class {
  width: 12vw;
}


/* 中等屏幕及以上（这里我们假设中等屏幕是指Bootstrap的md及以上断点）
   Bootstrap4的md断点大约是768px，可以根据需要调整 */
@media (max-width: 768px) {
  .i18n-class {
    width: 15vw;
  }
}

@media (max-width: 576px) {
  .i18n-class {
    width: 15vw;
  }
}

</style>